export default {
    en: {
      currencyFormat: {
        style: "currency",
        currency: "USD"
      }
    }
}